import { call, takeEvery } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import mixpanel from '../../helpers/mixpanel'
import skinTypes from '../../helpers/enums/skinTypes'

function* trackSelectedSkin(action: any) {
	const properties = {
		skin: skinTypes[action.settings.skin],
	}
	try {
		yield call(mixpanel.track, 'TTC Skin Selected', properties, false)
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error)
	}
}

export default [takeEvery(actionTypes.GAME_SETTINGS, trackSelectedSkin)]

export { trackSelectedSkin }
